<template>
    <v-form class="page-wpa-container">
        <div class="wpa-item">
            <span class="label">模板名称</span>
            <v-form-item
                :error-placement="'bottom'"
                v-model="form.templateName.error"
                :rules="form.templateName.rule"
                name="templateName"
            >
                <v-input
                    v-model="innerWpaFormData.templateName"
                    :limit="20"
                    class="wpa-input"
                    name="templateName"
                    placeholder="请输入"
                    required
                />
            </v-form-item>
        </div>
        <div class="wpa-item">
            <span class="label">应用位置</span>
            <common-select
                :dimension="(hasMigrated || isSsc) ? {} : appliesOption.dimension"
                :maps="appliesOption.maps"
                :multiple="true"
                :list-function="onFetchWpaList"
                :max-level="1"
                :count="15"
                :show-count="true"
                :select-all-btn="false"
                :clear-all-btn="false"
                :refresh-btn="true"
                :save-selected-switch="true"
                :select-required="false"
                @confirm="onWpaAppliesConfirm"
                :value="appliesSelected"
                clazz="web-tab-detail-applies-select-pop"
                search-placeholder="搜索接待组件名称"
            >
                <template slot="header">
                    <v-status-bar
                        kind="alarm"
                        size="medium"
                    >
                        <span class="select-tips">若选择的接待组件已有会话窗口样式，则新样式会覆盖老样式。</span>
                    </v-status-bar>
                </template>
                <template
                    slot="list-item"
                    slot-scope="props"
                >
                    <cell
                        :text="props.item.wpaName"
                        :highlight-text="props.searchValue"
                        pattern="icon_text"
                    />
                </template>
                <template slot="trigger">
                    <v-tip
                        ref="wpaApplysDetailRef"
                        :disabled="noWpaApplys"
                        placement="top"
                        kind="small"
                    >
                        <div class="wpa-applys-detail-tip">
                            <template v-if="!hasMigrated">
                                <template v-for="type in SHOW_USE_DETAIL_ORDER">
                                    <div
                                        :key="type"
                                        v-if="formatUseDetailMap(innerWpaFormData.nowWpaApplys)[type].length"
                                        class="detail-line"
                                    >
                                        <span class="label">{{ USE_DETAIL_TYPE_LABEL[type] }}</span>
                                        <span class="value">{{
                                            formatUseDetailMap(innerWpaFormData.nowWpaApplys)[type]
                                                .map(detail => detail.wpaName).join('，')
                                        }}</span>
                                    </div>
                                </template>
                            </template>
                            <span v-else class="value">{{
                                getUseDetails(innerWpaFormData.nowWpaApplys)
                                    .map(detail => detail.wpaName).join('，')
                            }}</span>
                        </div>
                    </v-tip>
                    <v-form-item
                        :error-placement="'bottom'"
                        v-tip:wpaApplysDetailRef.hover
                        name="wpaApplys"
                    >
                        <v-select
                            ref="wpaSelectRef"
                            :options="appliesInputOptions"
                            :value="appliesSelected"
                            @visibleChange="onWpaSelectVisibleChange"
                            class="wpa-select"
                            multiple
                            placeholder="请选择"
                        />
                    </v-form-item>
                </template>
            </common-select>
        </div>
        <div class="gap" />
    </v-form>
</template>

<script>
import Cell from 'src/components/cell';
import CommonSelect from 'src/components/market-common-select-panel';
import { USE_DETAIL_TYPE, USE_DETAIL_TYPE_LABEL, SHOW_USE_DETAIL_ORDER, formatUseDetailMap } from '../../web-tab-page/src/Index.vue';

const CHANNEL_TYPE_TO_DETAIL_TYPE_MAP = {
    webim: USE_DETAIL_TYPE.WEBIM,
    miniPlugin: USE_DETAIL_TYPE.MINI_PROGRAM_PLUGIN,
};

export default {
    name: 'Index',
    inject: ['channelType', 'context'],
    components: { CommonSelect, Cell },
    props: {
        wpaFormData: {
            type: Object,
            default: () => ({
                templateName: '',
                originWpaApplys: [],
                nowWpaApplys: [],
            }),
        },
        hasMigrated: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            form: {
                templateName: {
                    rule: [
                        { required: true, message: '请输入模板名称' },
                        { maxLength: 20, message: '最多可以输入20个字符' },
                    ],
                    error: '',
                },
            },
            innerWpaFormData: this.wpaFormData,
            // 应用位置的下拉框选项
            appliesOption: {
                dimension: {
                    isHas: true,
                    options: [
                        { text: '网页接待', value: 'webim' },
                        { text: '小程序插件接待', value: 'miniPlugin' },
                    ],
                    // 默认是互斥mutex, 还支持交集 merge
                    mode: 'merge',
                    default: 'webim',
                },
                maps: {
                    value: 'wpaId',
                    text: 'wpaName',
                },
            },

            USE_DETAIL_TYPE: Object.freeze(USE_DETAIL_TYPE),
            USE_DETAIL_TYPE_LABEL: Object.freeze(USE_DETAIL_TYPE_LABEL),
            SHOW_USE_DETAIL_ORDER: Object.freeze(SHOW_USE_DETAIL_ORDER),
        };
    },
    computed: {
        appliesInputOptions() {
            // 当前所有选项都传进去并且全部选中，以此来达到展示的效果
            return (this.innerWpaFormData.nowWpaApplys || []).map(item => ({
                text: item.wpaName,
                value: item.wpaId,
            })).concat([{ text: '空', value: 'empty' }]);
        },
        appliesSelected() {
            if(!this.hasMigrated) {
                return (this.innerWpaFormData.nowWpaApplys || []).map(item => item.wpaId);
            }
            const map = this.getUseDetails(this.innerWpaFormData.nowWpaApplys);
            return (map || []).map(item => item.wpaId);
        },
        noWpaApplys() {
            if(!this.hasMigrated) {
                return !(this.innerWpaFormData.nowWpaApplys || []).length;
            }
            const map = this.getUseDetails(this.innerWpaFormData.nowWpaApplys);
            return !(map || []).length;
        },
        isSsc() {
            return this.context.isSsc;
        },
    },
    watch: {
        wpaFormData(val) {
            this.init(val);
        },
        'form.templateName.error'(val) {
            this.$emit('setErrors', 'wpaFormData', Boolean(val));
        },
        innerWpaFormData: {
            handler(val) {
                this.$emit('getNowData', val.templateName, 'templateName');
                this.$emit('getNowData', val.nowWpaApplys, 'wpaApplys');
            },
            deep: true,
        },
    },
    methods: {
        init(formData) {
            this.innerWpaFormData = formData;
            // 消除所有错误提示
            Object.keys(this.form).forEach((key) => {
                this.form[key].error = '';
            });
        },
        onWpaSelectVisibleChange(visible) {
            if (visible) {
                this.$nextTick(() => {
                    // 这里只是使用vhtml1的下拉框样式来模拟展示，实际并不需要使用下拉能力，因此这里通过点击后立马关闭selector弹窗并弹出自定义的弹窗
                    const selectorPopper = this.$refs.wpaSelectRef && this.$refs.wpaSelectRef.$refs.selector;
                    if (selectorPopper) {
                        selectorPopper.hide();
                    }
                });
            }
        },
        onFetchWpaList(index, count, keyWord, channel) {
            let channelType;
            if (!this.hasMigrated) {
                channelType = channel === 'default' ? 'webim' : channel;
            } else {
                channelType = this.channelType === 1 ? 'miniPlugin' : 'webim';
            }
            const params = {
                index,
                count,
                keyWord,
                channelType,
            };

            return this.$ajax
                .gatewayPost('/v1/imRoute/listWpaInfoByChannel', params)
                .then(({ code, data, message }) => {
                    if (code !== 0) {
                        throw new Error(message);
                    }

                    return (data.records || []).map(item => ({
                        ...item,
                        wpaId: item.wpaID,
                        type: CHANNEL_TYPE_TO_DETAIL_TYPE_MAP[channelType],
                    }));
                })
                .catch((err) => {
                    this.$message.error(err.message);
                });
        },
        onWpaAppliesConfirm({ selected, options }) {
            // 找到selected里面options里面没有的，这些可能是一开始在originWpaApplys里面的
            const mayInOriginWpaApplyIds = selected.filter(id => !options.find(({ wpaId }) => wpaId === id));
            const mayInOriginWpaApplys = mayInOriginWpaApplyIds
                .map(id => this.innerWpaFormData.originWpaApplys.find(({ wpaId }) => wpaId === id));

            this.innerWpaFormData.nowWpaApplys = [...options, ...mayInOriginWpaApplys]
                .map(({ wpaId, wpaName, type }) => ({
                    wpaId,
                    wpaName,
                    type,
                }));
        },
        formatUseDetailMap,
        getUseDetails(useDetail) {
            const map = this.formatUseDetailMap(useDetail);
            const orderType = this.channelType === 1 ? this.USE_DETAIL_TYPE.MINI_PROGRAM_PLUGIN : this.USE_DETAIL_TYPE.WEBIM;
            return map[orderType];
        },
    },
};
</script>

<style lang="less">
.web-tab-detail-applies-select-pop {
    width: 478px;
    padding: 20px 16px !important;

    .common-select-panel {
        width: 100%;
    }

    .v-popconfirm__hd {
        margin-bottom: 8px;

        .v-status-bar__allmedium {
            .v-status-bar__logomedium {
                margin: 2px 0 0 8px;
            }

            .select-tips {
                color: var(--text-color-text-primary, rgba(0, 1, 11, 0.93));
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 20px; /* 142.857% */
            }
        }
    }
}
</style>
<style lang="less" scoped>
.wpa-applys-detail-tip {
    padding: 8px 10px;
    max-width: 400px;
    .detail-line {
        width: 400px;
        display: flex;
        margin-top: 12px;

        &:first-child {
            margin-top: 0;
        }

        .label {
            flex: 0 0 80px;
            color: var(--text-color-text-secondary, rgba(1, 10, 40, 0.65));
            font-family: PingFang SC;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px; /* 142.857% */
        }
    }
    .value {
        color: var(--text-color-text-primary, rgba(0, 1, 11, 0.93));
        font-family: PingFang SC;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
    }
}

.page-wpa-container {
    margin-top: 4px;

    .wpa-item {
        display: flex;
        align-items: center;
        margin-top: 20px;

        &:first-child {
            margin-top: 0;
        }

        .label {
            color: rgba(1, 11, 50, 0.41);
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 16px; /* 114.286% */
            width: 90px;
            margin-right: 8px;
        }

        .wpa-input,
        .wpa-select {
            width: 700px;
        }

        .wpa-input {
            /deep/ .v-input--default__star {
                margin-left: -40px;
            }
        }
        /deep/ .v-form-item__bterr {
            position: absolute;
            top: 28px;
        }

        .common-select {
            padding-bottom: 0;
        }
    }

    .gap {
        width: 100%;
        height: 1px;
        background: #E0E6F1;
        margin: 40px 0;
    }
}
</style>
